import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import AssignTechnicianToMaintenanceRepair, {
    AssignTechnicianToMaintenanceRepairProps
} from "../../../pages/consumers/maintenanceRepair/components/MaintenanceRepair/AssignTechnicianToMaintenanceRepair";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AssignTechnicianToMaintenanceRepairProps {
}

type Props = OwnProps;

// @ts-ignore
const AssignTechnicianToMaintenanceRepairModal = NiceModal.create<Props>(({maintenanceRepair, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver title={header} onClose={handleClose} open={modal.visible} afterClose={modal.remove}>
            <AssignTechnicianToMaintenanceRepair maintenanceRepair={maintenanceRepair}/>
        </SlideOver>
    )
})

export default AssignTechnicianToMaintenanceRepairModal;
